import { useState } from 'react'

import { ENTITY_PAGE_PROFILE_LAYOUT_WIDGETS_EXPAND_INITIAL_STATE } from './useEntityPageProfileLayoutWidgetsExpand.constants'
import {
  getEntityPageProfileLayoutCountedWidgetsState,
  getEntityPageProfileLayoutToggledAllState,
  hasEntityPageProfileLayoutCountedWidgets,
  isEntityPageProfileLayoutCollapseCommand,
  isEntityPageProfileLayoutToggleAllDoneByHand,
} from './useEntityPageProfileLayoutWidgetsExpand.utils'

export function useEntityPageProfileLayoutWidgetsExpand({
  entityKey,
  isAvailable,
}) {
  const [widgetsExpandState, setWidgetsExpandState] = useState(
    ENTITY_PAGE_PROFILE_LAYOUT_WIDGETS_EXPAND_INITIAL_STATE
  )
  const [expandCommandEntityKey, setExpandCommandEntityKey] =
    useState(entityKey)

  if (expandCommandEntityKey !== entityKey) {
    setExpandCommandEntityKey(entityKey)
    setWidgetsExpandState(state => ({ ...state, expandCommand: null }))
  }

  const { expandCommand } = widgetsExpandState

  const isAllCollapsed = isEntityPageProfileLayoutCollapseCommand(expandCommand)

  const hasCountedWidgets =
    hasEntityPageProfileLayoutCountedWidgets(widgetsExpandState)

  function registerCountedWidget({ isExpanded }) {
    setWidgetsExpandState(state =>
      getEntityPageProfileLayoutCountedWidgetsState({
        countChange: 1,
        isExpanded,
        state,
      })
    )

    return () => {
      setWidgetsExpandState(state =>
        getEntityPageProfileLayoutCountedWidgetsState({
          countChange: -1,
          isExpanded,
          state,
        })
      )
    }
  }

  function handleToggleAll() {
    setWidgetsExpandState(getEntityPageProfileLayoutToggledAllState)
  }

  function handleCountedWidgetToggle({ isExpanded }) {
    setWidgetsExpandState(state =>
      isEntityPageProfileLayoutToggleAllDoneByHand({ isExpanded, state })
        ? getEntityPageProfileLayoutToggledAllState(state)
        : state
    )
  }

  return {
    widgetsExpand: isAvailable
      ? {
          expandCommand,
          handleCountedWidgetToggle,
          handleToggleAll,
          hasCountedWidgets,
          isAllCollapsed,
          registerCountedWidget,
        }
      : null,
    widgetsKey: isAvailable ? entityKey : undefined,
  }
}
